import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var ExampleItems =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ExampleItems, _React$Component);

  function ExampleItems() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ExampleItems.prototype;

  _proto.render = function render() {
    var items = this.props.items;
    var customItems = items.slice(0);
    customItems.pop();

    if (customItems.length) {
      return React.createElement("div", null, React.createElement("h5", {
        className: "title"
      }, "EXAMPLES"), customItems.map(function (item, index) {
        var description = item.description,
            code = item.code;
        return React.createElement("div", {
          key: "tutorial-" + index
        }, description ? React.createElement("p", {
          className: "description"
        }, description) : null, React.createElement("pre", {
          className: "codeblock tui-language-javascript"
        }, React.createElement("code", {
          dangerouslySetInnerHTML: {
            __html: code
          }
        })));
      }));
    }

    return null;
  };

  return ExampleItems;
}(React.Component);

export default ExampleItems;